export enum GameSolutionCategory {
  SELECTION = 'selection',
  AREA = 'area'
}
